import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import EMPFilterSidebar from "../../shared/components/EMPFilterSidebar/EMPFilterSidebar";
import { UserContext } from "../../shared/context/userContext";

// will be refactored in a future story
export const DesktopFilters = ({
  filters,
  selectedFilters,
  onFilterChange,
  onFilterClear,
  hideClear,
  isDisabled,
  isLoading,
}) => {
  const { user } = useContext(UserContext) || {};
  const isLincoln = user?.brand === "L";
  return (
    <Box
      sx={{
        position: "sticky",
        top: "24px",
        height: isLincoln ? "auto" : "calc(100vh - 24px)",
        alignSelf: "start",
        gridColumn: "1",
        zIndex: 1,
        opacity: isLoading ? 0.7 : 1,
        pointerEvents: isLoading ? "none" : "auto",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: isLincoln ? "20px" : 6, height: isLincoln ? "32px" : "40px" }}
      >
        <Grid item>
          <Typography
            variant="h5"
            component="p"
            color="#4d4d4d"
            sx={
              isLincoln
                ? {
                    fontFamily: "ProximaNovaSemibold, Arial, sans-serif",
                    fontSize: "20px",
                    lineHeight: "28px",
                    letterSpacing: 0,
                  }
                : {}
            }
          >
            Filters
          </Typography>
        </Grid>
      </Grid>

      <EMPFilterSidebar
        filters={filters}
        selectedFilters={selectedFilters}
        onFilterChange={onFilterChange}
        onFilterClear={onFilterClear}
        hideClear={hideClear}
        disabled={isDisabled}
      />
    </Box>
  );
};

DesktopFilters.propTypes = {
  filters: PropTypes.object,
  selectedFilters: PropTypes.object,
  onFilterChange: PropTypes.func.isRequired,
  onFilterClear: PropTypes.func.isRequired,
  hideClear: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

DesktopFilters.defaultProps = {
  filters: {},
  selectedFilters: {},
  hideClear: false,
  isDisabled: false,
  isLoading: false,
};
